var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import api from './api'; // Importa a instância configurada
import { getHeader } from './header';
// Busca dados do Google Ads para um cliente e período
export var getGoogleAdsData = function (clientId, period, start, end) { return __awaiter(void 0, void 0, void 0, function () {
    var header, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                params = period === "custom"
                    ? { id: clientId, start: start, end: end }
                    : { id: clientId, period: period };
                return [2 /*return*/, api.post('/dashboards/get-googleads', params, header)];
        }
    });
}); };
// Busca dados do Facebook Ads para um cliente e período
export var getFacebookAdsData = function (clientId, period, start, end) { return __awaiter(void 0, void 0, void 0, function () {
    var header, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                params = period === "custom"
                    ? { id: clientId, start: start, end: end }
                    : { id: clientId, period: period };
                return [2 /*return*/, api.post('/dashboards/get-facebookads', params, header)];
        }
    });
}); };
// Busca dados do Instagram para um cliente e período
export var getInstagramData = function (clientId, period, start, end) { return __awaiter(void 0, void 0, void 0, function () {
    var header, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                params = period === "custom"
                    ? { id: clientId, start: start, end: end }
                    : { id: clientId, period: period };
                return [2 /*return*/, api.post('/dashboards/get-instagram', params, header)];
        }
    });
}); };
export var getCampaigns = function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [2 /*return*/, api.post('/dashboards/get-campaigns', { clientId: clientId }, header)];
        }
    });
}); };
export var updateCampaign = function (clientId, campaignId, data) { return __awaiter(void 0, void 0, void 0, function () {
    var header, payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                payload = {
                    clientId: clientId,
                    campaignId: campaignId,
                    platform: data.platform,
                };
                if (data.is_active !== undefined)
                    payload.is_active = data.is_active;
                if (data.description !== undefined)
                    payload.description = data.description;
                if (data.objective !== undefined)
                    payload.objective = data.objective;
                return [2 /*return*/, api.put('/dashboards/update-campaign', payload, header)];
        }
    });
}); };
export var getFacebookCampaignInsights = function (clientId, campaignId, period, start, end) { return __awaiter(void 0, void 0, void 0, function () {
    var header, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                params = period === "custom"
                    ? { clientId: clientId, campaignId: campaignId, start: start, end: end }
                    : { clientId: clientId, campaignId: campaignId, period: period };
                return [2 /*return*/, api.post('/dashboards/facebook-campaign-insights', params, header)];
        }
    });
}); };
export var getGoogleCampaignInsights = function (clientId, campaignId, period, start, end) { return __awaiter(void 0, void 0, void 0, function () {
    var header, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                params = period === "custom"
                    ? { clientId: clientId, campaignId: campaignId, start: start, end: end }
                    : { clientId: clientId, campaignId: campaignId, period: period };
                return [2 /*return*/, api.post('/dashboards/google-campaign-insights', params, header)];
        }
    });
}); };
// Busca campanhas salvas no banco (status true)
export var getCampaignsDb = function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [2 /*return*/, api.post('/dashboards/get-campaigns-db', { clientId: clientId }, header)];
        }
    });
}); };
export var getFacebookAdsGeneral = function (clientId, period, start, end) { return __awaiter(void 0, void 0, void 0, function () {
    var header, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                params = period === "custom"
                    ? { id: clientId, start: start, end: end }
                    : { id: clientId, period: period };
                return [2 /*return*/, api.post('/dashboards/get-facebookads-general', params, header)];
        }
    });
}); };
export var getFacebookAdsBreakdown = function (clientId, period, start, end) { return __awaiter(void 0, void 0, void 0, function () {
    var header, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                params = period === "custom"
                    ? { id: clientId, start: start, end: end }
                    : { id: clientId, period: period };
                return [2 /*return*/, api.post('/dashboards/get-facebookads-breakdown', params, header)];
        }
    });
}); };
export var getGoogleAdsGeneral = function (clientId, period, start, end) { return __awaiter(void 0, void 0, void 0, function () {
    var header, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                params = period === "custom"
                    ? { id: clientId, start: start, end: end }
                    : { id: clientId, period: period };
                return [2 /*return*/, api.post('/dashboards/get-googleads-general', params, header)];
        }
    });
}); };
export var getGoogleAdsBreakdown = function (clientId, period, start, end) { return __awaiter(void 0, void 0, void 0, function () {
    var header, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                params = period === "custom"
                    ? { id: clientId, start: start, end: end }
                    : { id: clientId, period: period };
                return [2 /*return*/, api.post('/dashboards/get-googleads-breakdown', params, header)];
        }
    });
}); };
